import React from 'react';

import { Company } from '@interfaces/ti50';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

interface CompanyDetailsProps {
  company: Company;
}

const CompanyDetails = ({ company }: CompanyDetailsProps) => {
  const handleCloseActionClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const target = event.currentTarget;
    const closestRow = target.closest('tr');
    const moreCompanyDetails = closestRow?.querySelector('div.more-company-details') as HTMLElement;
    const detailCell = closestRow?.querySelector("td[colspan='4']") as HTMLElement;

    if (moreCompanyDetails) {
      moreCompanyDetails.style.display = 'none';
      moreCompanyDetails.removeAttribute('data-slide-open');
    }
    if (closestRow) {
      closestRow.previousElementSibling?.classList.remove('selected-row');
    }
    if (detailCell) {
      detailCell.classList.remove('show-detail-border');
    }
    const company = closestRow?.previousElementSibling?.getAttribute('data-company');
    if (company) {
      document.querySelector(`tr[data-company="${company}"]`)?.scrollIntoView();
    }
  };

  return (
    <div className="more-company-details">
      {company.description && (
        <div className="description">
          <span className="header">Description</span>
          <p>{company.description}</p>
        </div>
      )}
      <div className="company-props">
        {company.location && (
          <div className="item location">
            <span className="header">Location</span>
            <p>{company.location}</p>
          </div>
        )}
        {company.founders && (
          <div className="item">
            {company.founders.split(',').length > 1 ? (
              <span className="header">Founders</span>
            ) : (
              <span className="header">Founder</span>
            )}
            <p>{company.founders}</p>
          </div>
        )}
        {company.founding_year && (
          <div className="item">
            <span className="header">Founding Year</span>
            <p>{company.founding_year}</p>
          </div>
        )}
        {company.employees && (
          <div className="item">
            <span className="header">No. of Employees</span>
            <p>{company.employees}</p>
          </div>
        )}
        {company.key_investors && (
          <div className="item">
            <span className="header">Key Investors</span>
            <p>{company.key_investors}</p>
          </div>
        )}
        {company.website && (
          <div className="item">
            <span className="header">Website</span>
            <p>
              <a
                className="underline hover:text-primary-magenta dark:hover:text-primary-pink"
                href={`https://${company.website}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                {company.website}
              </a>
            </p>
          </div>
        )}
      </div>
      <div className="values">
        {company.revenue_value && (
          <div className="value-item">
            <div>Revenue</div>
            <div>
              <p className="value">{company.revenue_value}</p>
              {company.revenue_excerpt && <p className="excerpt">{company.revenue_excerpt}</p>}
            </div>
          </div>
        )}
        {company.money_raised && (
          <div className="value-item">
            <div>Equity Funding</div>
            <div>
              <p className="value">{company.money_raised}</p>
            </div>
          </div>
        )}
      </div>
      {company.why_it_made_the_list && (
        <div>
          <span className="header">Why it made the list</span>
          <div className="why__description">
            {AuthoredContentReactToHtmlParser(company.why_it_made_the_list)}
          </div>
        </div>
      )}
      <div className="close-container">
        <span className="close-action" onClick={handleCloseActionClick}>
          &times;
        </span>
      </div>
    </div>
  );
};

export default CompanyDetails;
